import { Logout, LogoutResponse } from '../../../types/logout';
import { ApiAbstract } from '../abstract';

export class ApiLogout extends ApiAbstract<LogoutResponse, Logout> {}
